import React, { useEffect, useState } from 'react';
import usePopup from '../../../../../hooks/usePopup';
import InlineDialog from '../../../../InlineDialog';
import Button from '../../../../../kingpin/atoms/Button';
import dateRangeInputToAmericanLabel from '../../../../../dateRangeInputToAmericanLabel';
import PeriodRefiner from './PeriodRefiner';

const PeriodRefinerContainer = ({
  maxDate,
  minDate,
  dateRangeChanged,
}: {
  maxDate: string;
  minDate: string;
  dateRangeChanged: (dateRange: DateRangeInput) => void;
}) => {
  const { close, isOpen, open } = usePopup();
  const [selectedStartDate, setSelectedStartDate] = useState<string>(minDate);
  const [selectedEndDate, setSelectedEndDate] = useState<string>(maxDate);

  useEffect(() => {
    dateRangeChanged({
      startDate: selectedStartDate,
      endDate: selectedEndDate,
    });
  }, [dateRangeChanged, selectedEndDate, selectedStartDate]);

  return (
    <InlineDialog
      isOpen={isOpen}
      onClose={close}
      content={
        <PeriodRefiner
          minDate={minDate}
          maxDate={maxDate}
          startDate={selectedStartDate}
          endDate={selectedEndDate}
          setStartDate={setSelectedStartDate}
          setEndDate={setSelectedEndDate}
        />
      }
    >
      <Button
        size={'Medium'}
        onClick={isOpen ? close : open}
        type={'Secondary'}
        label={dateRangeInputToAmericanLabel({
          startDate: selectedStartDate,
          endDate: selectedEndDate,
        })}
      />
    </InlineDialog>
  );
};

const Gate = ({
  dateRangeWindow,
  dateRangeChanged,
}: {
  dateRangeWindow: DateRangeInput;
  dateRangeChanged: (dateRange: DateRangeInput) => void;
}) => {
  if (!dateRangeWindow.startDate || !dateRangeWindow.endDate) {
    return null;
  }

  return (
    <PeriodRefinerContainer
      dateRangeChanged={dateRangeChanged}
      maxDate={dateRangeWindow.endDate}
      minDate={dateRangeWindow.startDate}
    />
  );
};

export default Gate;
